<template>
  <div class="content">
    <div class="search-page-layout">
      <div class="main-content">
        <div class="top-bar-wrapper">
          <search-top-bar v-on:action-search="search"/>
        </div>
        <div class="filter-bar-wrapper">
          <search-filters/>
        </div>
        <div class="loader" v-if="requesting || loading">
          <loader/>
        </div>
        <template v-else>
          <div class="content-container" v-if="rooms.length > 0">
            <h1 v-if="rooms.length < 2"><span>{{ rooms.length }}</span> {{ $t('v2.search.title.singular') }}</h1>
            <h1 v-else><span>{{ rooms.length }}</span> {{ $t('v2.search.title.plural') }}</h1>
            <div class="room-container">
              <search-result-room
                  v-for="(room, index) in roomList"
                  :index="index"
                  :key="`${room.id}_${room.computedPrices.length}`"
                  :ref="`room_${room.id}`"
                  v-on:loading="handelRoomLoading"
                  :room="room"/>
            </div>
          </div>
          <div class="content-container not-found" v-if="rooms.length === 0 && noRooms">
            <h1>{{ $t('v2.search.title.not_found.0') }}</h1>
            <h2>{{ $t('v2.search.title.not_found.1') }}</h2>
          </div>
          <div class="content-container" v-if="rooms.length === 0 && !noRooms">
            <h1><span>0</span> {{ $t('v2.search.title.singular') }}</h1>
          </div>
        </template>
      </div>
      <div class="map-content">
        <search-map/>
      </div>
    </div>
  </div>
</template>

<script>
import SearchTopBar from "./parts/search-top-bar";
import SearchFilters from "./parts/search-filters";
import SearchSorter from "./parts/search-sorter";
import {mapState} from "vuex";
import SearchResultRoom from "./parts/search-result-room";
import SearchMap from "./parts/search-map";
import '../../../static/style3/search.css';
import Loader from "../../components/loader.component";
import VueScrollTo from "vue-scrollto";
import {MetaHelper} from "../../helpers/meta.helper";

export default {
  name: "search",
  components: {Loader, SearchMap, SearchResultRoom, SearchSorter, SearchFilters, SearchTopBar},
  metaInfo() {
      return MetaHelper.search(this.$store.state.lang.currentLang)
  },
  data() {
    return {
      loading: false,
      searchLaunched: false,
    }
  },
  watch: {
    selected(v) {
      if (v) {
        this.scrollToRoom(v);
      }
    },
    requesting() {
      this.searchLaunched = true;
    }
  },
  computed: {
    rooms() {
      return this.$store.getters["search/rooms"];
    },
    roomList() {
      return this.$store.getters["search/roomList"];
    },
    noRooms() {
      return this.$store.getters["search/hasDates"] && this.searchLaunched && this.available === 0;
    },
    ...mapState({
      requesting: s => s.search.requesting,
      selected: s => s.search.selected,
      available: s => s.search.available_rooms.length,
    }),
  },
  mounted() {
    window.addEventListener('app:scroll_top', this.handleScroll);
    if (this.selected) {
      this.scrollToRoom(this.selected);
    }
  },
  beforeDestroy() {
    window.removeEventListener('app:scroll_top', this.handleScroll);
  },
  methods: {
    scrollToRoom(v) {
      const el = this.$refs['room_' + v][0];
      if (el) {
        VueScrollTo.scrollTo(el.$el, 500, {
          offset: -200
        })
        setTimeout(() => {
          this.$store.commit('search/SET_SELECTED', null);
        }, 2500);
      }
    },
    handleScroll () {
      const element = document.querySelector('.room-container');
      VueScrollTo.scrollTo(element, 500, {
        offset: -200
      })
    },
    async search(params = {}) {
      await this.$store.dispatch('search/process', params);
    },
    handelRoomLoading(v) {
      this.loading = v;
    }
  }
}
</script>

<style scoped>
.not-found h1 {

}

.not-found h2 {
  font-weight: 200;
  font-size: 1.4em;
  text-align: center;
}

.loader {
  height: 80px;
}

.filter-right {
  margin: auto 0 auto auto;
}

.info-block {
  font-family: Sofia Pro, sans-serif;
  font-size: 1em;
  border: 2px solid #999;
  color: #444;
  margin: .25rem 2.75rem;
  padding: 0 20px;
  text-align: center;
}

.info-block.errored {
  color: var(--red);
  border-color: var(--red);
}
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue